import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import profile from "../../assets/profile.svg";
import { getSx } from "./style";
import BreadCrumbComponent from "../../components/BreadCrumbs";
import { getUserDetail } from "../../http/auth";
import { useSearchParams } from "react-router-dom";
import Spinner from "../../components/Spinner";

const UserDetail = () => {
  const [userData, setUserData] = useState({});
  const [loading, setLoading] = useState(false);

  const [searchParams] = useSearchParams();

  const classes = getSx();

  React.useEffect(() => {
    getUserData();
  }, []);

  const getUserData = async () => {
    try {
      setLoading(true);
      const id = searchParams.get("id");
      const response = await getUserDetail(id);
      setUserData(response.data?.data?.user);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <Box width="100%">
      <BreadCrumbComponent heading1="Manage Users" heading2="User Details" />
      {!loading ? (
        <Box sx={classes.content}>
          <Box sx={classes.contentBox}>
            <Box sx={classes.imageWrapper}>
              <LazyLoadImage
                className={"product-img-tag"}
                data-wow-delay=".3s"
                src={profile}
                effect="blur"
                style={{
                  width: window.innerWidth < 900 ? "177px" : "210px",
                  height: "224px",
                  animationName: "fadeInUp",
                  animationDelay: "0.3s",
                  objectFit: "fill",
                  borderRadius: "32px",
                  marginTop: "7px",
                }}
              />
            </Box>
            <Box sx={classes.rightBoxContainer}>
              <Typography sx={{ ...classes.name, textTransform: "capitalize" }}>
                Name: <span style={classes.lightText}>{userData.name ?? "N/A"}</span>
              </Typography>
              <Typography sx={classes.name}>
                Email: <span style={classes.lightText}>{userData.email ?? "N/A"}</span>
              </Typography>
              <Typography sx={classes.name}>
                Phone Number: <span style={classes.lightText}>{userData.phone ?? "N/A"}</span>
              </Typography>
              <Typography sx={classes.name}>
                Status: <span style={classes.lightText}>{userData.status ?? "N/A"}</span>
              </Typography>
            </Box>
          </Box>
        </Box>
      ) : (
        <Spinner />
      )}
    </Box>
  );
};

export default UserDetail;
